/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { LapHistData, OriginType, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class LapDataHistoryStreamService extends RSocketStreamBaseService<LapHistData[], LapHistData> {
  protected async getStreamHistoryRequest(): Promise<LapHistData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/lapHistory', this.request)
      .then((response) => {
        return response.data as LapHistData[];
      })
      .catch(() => {
        return [];
      });
  }

  protected onDataCallback = (response: LapHistData) => {
    if (this.listeners.size > 0) {
      const lapDataObject = response;
      const currentLapDataHistory = this.localCache;
      const lap: LapHistData | undefined = currentLapDataHistory.find(
        (lapDataHistory) => lapDataHistory.lap === lapDataObject.lap
      );

      // Check if this incoming vehicle's Previous Lap Data (LapData.previouslapmetadata)
      // already exists in the history (LapHistData.vehiclemetadataList).
      if (!lap) {
        this.localCache = [...currentLapDataHistory, lapDataObject];
      } else {
        this.localCache = [...currentLapDataHistory.filter((value) => value.lap !== lap.lap), lapDataObject];
      }
    }
  };

  async start() {
    this.delay = 1000;
    super.start();
  }
}

export const lapDataHistoryStreamServiceCollection: Map<
  SanctioningBodyEnum,
  Map<OriginType, LapDataHistoryStreamService>
> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new Map(
        (Object.values(OriginType) as OriginType[])
          .filter((x) => typeof x === 'number')
          .map((source: OriginType) => [
            source,
            new LapDataHistoryStreamService({
              route: 'stream.lapHistory',
              connectionType: StreamRequestType.MotorsportsStreamApi,
              originType: source,
              sanctioningBody: sanctioningBody,
            }),
          ])
      ),
    ])
);
